var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "myToken",
    class: _vm.isMobile && 'wap'
  }, [_c('p-head'), _c('div', {
    staticClass: "myToken-main main",
    class: _vm.isMobile && 'wap'
  }, [!_vm.isMobile ? _c('div', {
    staticClass: "myToken__title btn",
    on: {
      "click": _vm.reload
    }
  }, [_vm._v(_vm._s(_vm.$lang("My Tokens")))]) : _vm._e(), _c('div', {
    staticClass: "myToken__tab"
  }, [_c('p-tab', {
    attrs: {
      "tab": _vm.tab,
      "selectTab": _vm.selectTab,
      "width": !_vm.isMobile ? 'auto' : '1'
    },
    on: {
      "update:selectTab": function ($event) {
        _vm.selectTab = $event;
      },
      "update:select-tab": function ($event) {
        _vm.selectTab = $event;
      }
    }
  })], 1), _vm.isWallet ? [_vm.selectTab === 'tokensihold' ? [_c('div', {
    staticClass: "myToken-hold",
    class: !_vm.myToken || _vm.myToken.length <= 0 && 'hEmpty'
  }, [_vm.isMyTokenLoading ? _vm._l(6, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "index-item"
    }, [_c('p-index-list-item', {
      attrs: {
        "isEmpty": true
      }
    })], 1);
  }) : [_vm.myToken && _vm.myToken.length > 0 ? _vm._l(_vm.myToken, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "myToken-item"
    }, [_c('p-index-list-item', {
      attrs: {
        "detail": item
      }
    })], 1);
  }) : [_c('m-empty', {
    attrs: {
      "isBtn": true,
      "content": "No tokens!",
      "btnText": "Explore Tokens"
    },
    on: {
      "confirm": _vm.onSkip
    }
  })]]], 2), _vm.myToken && _vm.myToken.length > 0 && _vm.myTokenPage.total > _vm.myTokenPage.perPage ? [_c('m-page', {
    attrs: {
      "total": _vm.myTokenPage.total,
      "page-size": _vm.myTokenPage.perPage,
      "page": _vm.myTokenPage.page,
      "on-page-change": _vm.onMyTokenPage
    }
  })] : _vm._e()] : _vm.selectTab === 'launchedbyme' ? [_c('div', {
    staticClass: "myToken-hold",
    class: _vm.myLaunched && _vm.myLaunched.length <= 0 && !_vm.isMyLaunchedLoading && 'me'
  }, [[_vm.isMyLaunchedLoading ? _vm._l(6, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "index-item"
    }, [_c('p-index-list-item', {
      attrs: {
        "isEmpty": true
      }
    })], 1);
  }) : [_vm.myLaunched && _vm.myLaunched.length <= 0 ? [_c('div', {
    staticClass: "myToken-add hover",
    style: {
      background: `url(${require('@images/ui/btn-add-bg.jpg')}) center/100% auto no-repeat`
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('img', {
    attrs: {
      "src": require('@images/ui/btn-add-icon.png'),
      "alt": ""
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$lang("Launch Token")))])])] : _vm._l(_vm.myLaunched, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "myToken-item"
    }, [_c('p-index-list-item', {
      attrs: {
        "detail": item
      }
    })], 1);
  })]]], 2), _vm.myLaunched && _vm.myLaunched.length > 0 && _vm.myLaunchedPage.total > _vm.myLaunchedPage.perPage ? [_c('m-page', {
    attrs: {
      "total": _vm.myLaunchedPage.total,
      "page-size": _vm.myLaunchedPage.perPage,
      "page": _vm.myLaunchedPage.page,
      "on-page-change": _vm.onMyLaunchedPage
    }
  })] : _vm._e()] : _vm._e()] : [_c('m-empty', {
    attrs: {
      "isBtn": true,
      "content": "Please connect Wallet!",
      "btnText": "Connect Wallet"
    },
    on: {
      "confirm": _vm.doConnect
    }
  })]], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };